/**
 * KBG v2 — Compare: filter radios + mobile row limit
 */
(function () {
  'use strict';

  if (window.__kbgV2CompareInit >= 2) return;
  window.__kbgV2CompareInit = 2;

  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var DEFAULT_LIMIT = 4;

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function getLimit(section) {
    var raw = parseInt(section.getAttribute('data-kbg-mobile-limit'), 10);
    return raw > 0 ? raw : DEFAULT_LIMIT;
  }

  function getFilterChip(section) {
    return (
      section.querySelector('[data-kbg-filter][aria-checked="true"]') ||
      section.querySelector('[data-kbg-filter]')
    );
  }

  function getFilter(section) {
    var active = getFilterChip(section);
    return active ? active.getAttribute('data-kbg-filter') : 'all';
  }

  function rowMatches(tr, filter) {
    var tags = ' ' + (tr.getAttribute('data-tags') || '') + ' ';
    return filter === 'all' || tags.indexOf(' ' + filter + ' ') !== -1;
  }

  function setRowVisible(tr, show) {
    tr.hidden = !show;
    if (show) {
      tr.removeAttribute('inert');
    } else {
      tr.setAttribute('inert', '');
    }
  }

  function syncFilterTabs(section, selected) {
    qsa(section, '[data-kbg-filter]').forEach(function (chip) {
      var on = chip === selected;
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.tabIndex = on ? 0 : -1;
    });
  }

  function updateFilterStatus(section, visible, chip) {
    var status = section.querySelector('[data-kbg-compare-status]');
    if (!status) return;

    var template =
      section.getAttribute('data-filter-status') || 'Showing {count} keyboards';
    var label = chip ? chip.textContent.trim() : '';
    var message = template.replace('{count}', String(visible));

    if (label) {
      message += ' — ' + label;
    }

    status.textContent = message;
  }

  function syncScrollTab(section) {
    var scroller = section.querySelector('.table-scroll');
    if (!scroller) return;
    var overflow = scroller.scrollWidth > scroller.clientWidth + 1;
    if (overflow) {
      if (!scroller.hasAttribute('tabindex')) scroller.setAttribute('tabindex', '0');
    } else if (document.activeElement !== scroller) {
      scroller.removeAttribute('tabindex');
    }
  }

  function applyRows(section) {
    var filter = getFilter(section);
    var chip = getFilterChip(section);
    var collapsed = section.getAttribute('data-kbg-collapsed') !== 'false';
    var limit = isMobile() && collapsed ? getLimit(section) : Infinity;
    var matching = 0;
    var visible = 0;

    qsa(section, 'tbody tr').forEach(function (tr) {
      var match = rowMatches(tr, filter);
      if (match) matching += 1;
      var show = match && matching <= limit;
      setRowVisible(tr, show);
      if (show) visible += 1;
    });

    var moreWrap = section.querySelector('[data-kbg-compare-more-wrap]');
    var moreBtn = section.querySelector('[data-kbg-compare-more]');
    var canToggle = isMobile() && matching > getLimit(section);

    if (moreWrap) moreWrap.hidden = !canToggle;
    if (moreBtn) {
      moreBtn.hidden = !canToggle;
      moreBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      var moreLabel = moreBtn.getAttribute('data-kbg-label-more') || 'View More';
      var lessLabel = moreBtn.getAttribute('data-kbg-label-less') || 'View Less';
      moreBtn.textContent = collapsed ? moreLabel : lessLabel;
    }

    updateFilterStatus(section, visible, chip);
    syncScrollTab(section);
  }

  function selectFilter(section, chip) {
    if (!chip) return;
    syncFilterTabs(section, chip);
    applyRows(section);
  }

  function expandRows(section) {
    var filter = getFilter(section);
    var limit = getLimit(section);
    var matching = 0;
    var firstNew = null;

    qsa(section, 'tbody tr').forEach(function (tr) {
      if (!rowMatches(tr, filter)) return;
      matching += 1;
      if (matching === limit + 1) firstNew = tr;
    });

    section.setAttribute('data-kbg-collapsed', 'false');
    applyRows(section);

    if (!firstNew) return;
    var cell = firstNew.querySelector('.cmp-name') || firstNew.cells[0];
    if (!cell) return;
    cell.setAttribute('tabindex', '-1');
    try {
      cell.focus({ preventScroll: false });
    } catch (error) {
      cell.focus();
    }
  }

  function collapseRows(section) {
    section.setAttribute('data-kbg-collapsed', 'true');
    applyRows(section);
    var moreBtn = section.querySelector('[data-kbg-compare-more]');
    if (moreBtn) moreBtn.focus();
  }

  function initSection(section) {
    if (!section || section.hasAttribute('data-kbg-compare-ready')) return;
    section.setAttribute('data-kbg-compare-ready', '');
    var selected = getFilterChip(section) || section.querySelector('[data-kbg-filter]');
    if (selected) syncFilterTabs(section, selected);
    applyRows(section);
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-kbg-compare-more]');
    if (more) {
      var moreSection = more.closest('[data-kbg-compare]');
      if (!moreSection) return;
      e.preventDefault();
      var collapsed = moreSection.getAttribute('data-kbg-collapsed') !== 'false';
      if (collapsed) {
        expandRows(moreSection);
      } else {
        collapseRows(moreSection);
      }
      return;
    }

    var chip = e.target.closest('[data-kbg-filter]');
    if (!chip) return;
    var section = chip.closest('[data-kbg-compare]');
    if (!section) return;
    selectFilter(section, chip);
  });

  document.addEventListener('keydown', function (e) {
    var chip = e.target.closest('[data-kbg-filter]');
    if (!chip) return;
    var section = chip.closest('[data-kbg-compare]');
    if (!section) return;
    var chips = qsa(section, '[data-kbg-filter]');
    var current = chips.indexOf(chip);
    if (current === -1) return;

    var nextIndex = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIndex = (current + 1) % chips.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIndex = (current - 1 + chips.length) % chips.length;
    } else if (e.key === 'Home') {
      nextIndex = 0;
    } else if (e.key === 'End') {
      nextIndex = chips.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    selectFilter(section, chips[nextIndex]);
    chips[nextIndex].focus();
  });

  function initAll(root) {
    qsa(root || document, '[data-kbg-compare]').forEach(initSection);
  }

  function refreshAll() {
    qsa(document, '[data-kbg-compare]').forEach(applyRows);
  }

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', refreshAll);
  } else if (typeof MOBILE_MQ.addListener === 'function') {
    MOBILE_MQ.addListener(refreshAll);
  }

  window.addEventListener('resize', function () {
    qsa(document, '[data-kbg-compare]').forEach(syncScrollTab);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
